import React from 'react'

export default function EnvelopeTick(props) {
    return (
        <svg {...props} width='20' height='20' viewBox='0 0 20 20' fill='none' xmlns='http://www.w3.org/2000/svg'>
            <path
                d='M18.3307 10.833V4.99967C18.3307 4.55765 18.1551 4.13372 17.8426 3.82116C17.53 3.5086 17.1061 3.33301 16.6641 3.33301H3.33073C2.8887 3.33301 2.46478 3.5086 2.15222 3.82116C1.83966 4.13372 1.66406 4.55765 1.66406 4.99967V14.9997C1.66406 15.9163 2.41406 16.6663 3.33073 16.6663H9.9974'
                stroke='currentColor'
                strokeWidth='1.25'
                strokeLinecap='round'
                strokeLinejoin='round'
            />
            <path
                d='M18.3307 5.83301L10.8557 10.583C10.5985 10.7442 10.301 10.8297 9.9974 10.8297C9.6938 10.8297 9.39634 10.7442 9.13906 10.583L1.66406 5.83301'
                stroke='currentColor'
                strokeWidth='1.25'
                strokeLinecap='round'
                strokeLinejoin='round'
            />
            <path
                d='M13.3359 15.8337L15.0026 17.5003L18.3359 14.167'
                stroke='currentColor'
                strokeWidth='1.25'
                strokeLinecap='round'
                strokeLinejoin='round'
            />
        </svg>
    )
}
